import MainNavContainer from './Navigation/containers/MainNavContainer';
import MobileNavContainer from './Navigation/containers/MobileNavContainer';
import RightSideMenuContainer from './Navigation/containers/RightSideMenuContainer';
import BreadcrumbsContainer from './Search/containers/BreadcrumbsContainer';
import NavSearchContainer from './Search/containers/NavSearchContainer';
import TopNavigationWrapper from './TopNavigation/TopNavigationWrapper';

const NavApps = {
  'main-nav': MainNavContainer,
  'mobile-nav': MobileNavContainer,
  'unifiedNav-search-app': NavSearchContainer,
  'right-side-menu': RightSideMenuContainer,
  'bread-crumbs': BreadcrumbsContainer,
  'new-top-nav': TopNavigationWrapper,
};

export default NavApps;
